import React, { Component } from 'react';
import { connect } from 'react-redux';

import { findPurchase } from '../../actions/purchases';
import { chargeCard } from '../../api';
import ConfirmModal from '../ConfirmModal/ConfirmModal';

class ChargePurchase extends Component {
  state = {
    isSent: false,
    selected: undefined,
    error: undefined,
    isOpenModal: false,
    cvc: '',
    cvcRequired: false,
    cvcError: '',
  };

  openModal = () => {
    this.setState({ isOpenModal: true });
  };

  closeModal = () => {
    this.setState({
      isOpenModal: false,
      cvcRequired: false,
      cvcError: '',
      cvc: '',
    });
  };

  getCardOptionLabel = (card) => {
    if (card.echeck_type) {
      return card.account_number;
    }

    return `${card.card_brand} ${card.card_last_four} (${card.expiration_month}/${card.expiration_year})`;
  };

  chargePurchase = async () => {
    const { purchaseId, cards, findPurchase, requiresCSV } = this.props;

    if (cards.length === 0) {
      return;
    }
    const { id } = cards.find((card) => card.is_default) || cards[0];
    const { selected = id, cvc } = this.state;

    this.setState({ cvcRequired: false, cvcError: '' });

    if (requiresCSV && !cvc) {
      this.setState({ cvcRequired: true });
      return;
    }

    try {
      await chargeCard(purchaseId, selected, cvc);
    } catch (err) {
      if (err.response.data && err.response.data.cvc) {
        this.setState({
          cvcError:
            typeof err.response.data.cvc === 'object' &&
            err.response.data.cvc[0]
              ? err.response.data.cvc[0]
              : err.response.data.cvc,
        });
        return;
      }
      this.setState({
        isSent: false,
        error:
          (err.response.data && err.response.data.detail) ||
          JSON.stringify(err.response.data) ||
          'An error occurred',
      });
      this.closeModal();
      return;
    }

    this.setState({
      isSent: true,
    });

    findPurchase(purchaseId);
    this.closeModal();
  };

  changeCvc = (e) => {
    const { value } = e.target;
    this.setState({
      cvc: value,
    });
  };

  renderDesc = () => {
    const { selected, cvc, cvcRequired, cvcError } = this.state;
    const { cards, requiresCSV } = this.props;

    const isDefault = cards.find((card) => card.is_default) || cards[0];
    const selectedCard =
      cards.find((card) => card.id === selected) || isDefault;
    return (
      <React.Fragment>
        Are you sure you would like to continue with charging card ending in{' '}
        {selectedCard &&
          (selectedCard.card_last_four || selectedCard.account_number)}
        ?
        <br />
        {requiresCSV ? (
          <span>
            Please enter CVC <input value={cvc} onChange={this.changeCvc} />
            {cvcRequired && (
              <span style={{ paddingLeft: '15px' }} className="text-danger">
                CVC field is required
              </span>
            )}
            {cvcError && (
              <React.Fragment>
                <br />
                <span className="text-danger">{cvcError}</span>
              </React.Fragment>
            )}
          </span>
        ) : (
          ''
        )}
      </React.Fragment>
    );
  };

  render() {
    const { purchaseId, cards } = this.props;
    const { isSent, error, isOpenModal } = this.state;

    if (cards.length === 0) {
      return null;
    }

    const isDefault = cards.find((card) => card.is_default) || cards[0];

    return purchaseId ? (
      <div className="mar-t">
        <h4>Charge Purchase</h4>
        <div className="input-group">
          <select
            className="form-control"
            defaultValue={isDefault.id}
            onChange={(e) => this.setState({ selected: e.target.value })}
          >
            {cards.map((card) => (
              <option key={card.id} value={card.id}>
                {this.getCardOptionLabel(card)}
              </option>
            ))}
          </select>
          <span className="input-group-btn">
            <button
              className="btn btn-danger"
              type="button"
              disabled={isSent}
              onClick={() => this.openModal()}
            >
              Charge this card
            </button>
          </span>
        </div>
        {isSent ? (
          <span className="text-success mar-t">
            Purchase has been successfully charged.
          </span>
        ) : null}
        {error ? <span className="text-danger mar-t">{error}</span> : null}
        <ConfirmModal
          isOpen={isOpenModal}
          title="Confirm card charging"
          description={this.renderDesc()}
          onClose={this.closeModal}
          onConfirm={this.chargePurchase}
          closeOnConfirmClick={false}
        />
      </div>
    ) : null;
  }
}

const mapDispatchToProps = {
  findPurchase,
};

export default connect(null, mapDispatchToProps)(ChargePurchase);
